import useApi from "../utils/useApi";
import React, { useEffect, useState } from "react";
import GroupLevelFormPopup from "./GroupLevelFormPopup";
import AccountRegFormPopup from "./AccountRegFormPopup";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

import BudgetCreationPopup from "./BudgetCreationPopup";
import { mockGroups } from "../components/salesInvoice/data";
import {
  BookOpen,
  ChevronRight,
  Database,
  Edit2,
  Edit3,
  Filter,
  Folder,
  Hash,
  Layers,
  LayoutGrid,
  Plus,
  Search,
} from "lucide-react";
import Modal from "../components/common/CommonModal";

const GroupAndLedgerManagement = () => {

  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";

  let API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";

  const BASE_URL =
    API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";

  const [department_to_pass_to_api, setDepartment_to_pass_to_api] =
    useState("");

  const [userDepartmentList, setUserDepartment] = useState(null);

  const [selectAccGroupRow, setSelectAccGroupRow] = useState(null);
  const [filteredAccList, setFilteredAccList] = useState(null);

  const [filteredAccListByType, setFilteredAccListByType] = useState(null);
  const [searchTextFilterTable, setSearchTextFilterTable] = useState("");
  const [searchTextFilterTableByType, setSearchTextFilterTableByType] =
    useState("");
  const [accToEdit, setAccToEdit] = useState(null);
  const [accToEditAccountForm, setAccToEditAccountForm] = useState(null);
  const [showGroupLevelForm, setShowGroupLevelForm] = useState(false);
  const [showAccountRegForm, setShowAccountRegForm] = useState(false);

  const [selectedGroup, setSelectedGroup] = useState(mockGroups[0]);
  const [selectedSubGroup, setSelectedSubGroup] = useState(
    mockGroups[0].ledgers[0].sublist
  );
  const {
    data: datagetAccTypeList,
    loading: loadinggetAccTypeList,
    error: errorgetAccTypeList,
    get: getAccTypeList,
  } = useApi();
  const {
    data: datagetAccDataByTpe,
    loading: loadinggetAccDataByTpe,
    error: errorgetAccDataByTpe,
    get: getAccDataByTpe,
  } = useApi();

  useEffect(() => {
    if (datagetAccTypeList) {
      setFilteredAccList(datagetAccTypeList);

      setSelectAccGroupRow(datagetAccTypeList[0]);
    }
  }, [datagetAccTypeList]);

  useEffect(() => {
    if (datagetAccDataByTpe) {
      setFilteredAccListByType(datagetAccDataByTpe);
    }
  }, [datagetAccDataByTpe]);

  useEffect(() => {
    if (searchTextFilterTable?.length > 0) {
      const filtered = datagetAccTypeList?.filter(
        (user) =>
          user.DESCRIPTION.toLowerCase().includes(
            searchTextFilterTable.toLowerCase()
          ) ||
          user.TYPE?.trim()
            ?.toLowerCase()
            .includes(searchTextFilterTable.toLowerCase())
      );
      setFilteredAccList(filtered);
    } else {
      setFilteredAccList(datagetAccTypeList);
    }
  }, [searchTextFilterTable]);

  useEffect(() => {
    console.log("searchTextFilterTableByType -->", searchTextFilterTableByType);
    if (searchTextFilterTableByType?.length > 0) {
      const filtered = datagetAccDataByTpe?.filter(
        (user) =>
          user.DESCRIPTION.toLowerCase().includes(
            searchTextFilterTableByType.toLowerCase()
          ) ||
          user.ACCOUNT?.trim()
            ?.toLowerCase()
            .includes(searchTextFilterTableByType.toLowerCase()) ||
          user["DEFAULT NARRATION"]
            ?.trim()
            ?.toLowerCase()
            .includes(searchTextFilterTableByType.toLowerCase())
      );
      setFilteredAccListByType(filtered);
    } else {
      setFilteredAccListByType(datagetAccDataByTpe);
    }
  }, [searchTextFilterTableByType]);

  const successfullyDone = () => {
    alert("Success");

    // setShowGroupLevelForm((prev) => !prev);

    setAccToEdit(null);

    let idTopass = selectedGroup?.id;
    console.log("successfullyDone");
    getAccTypeList(
      `${BASE_URL}/api/CRMGLSettings/${COMPANY_CODE}/ACTYPELIST/${idTopass}/-/-/-`
    );
  };

  useEffect(() => {
    if (selectAccGroupRow) {
      let dynamicDept =
        department_to_pass_to_api?.trim() === ""
          ? "-"
          : department_to_pass_to_api?.trim();

      let accTypeNumber = selectAccGroupRow?.TYPE?.trim();
      let apiUrl = `${BASE_URL}/api/CRMGLSettings/${COMPANY_CODE}/ACCOUNTSBYTYPE/${accTypeNumber}/-/${dynamicDept}/-`;
      console.log("apiurl ->[[[[]]]] ", selectAccGroupRow, apiUrl);
      getAccDataByTpe(apiUrl);
    }
  }, [selectAccGroupRow, department_to_pass_to_api]);

  useEffect(() => {
    console.log("selectedGroup", selectedGroup);
    if (selectedGroup) {
      let idTopass = selectedGroup?.id;
      getAccTypeList(
        `${BASE_URL}/api/CRMGLSettings/${COMPANY_CODE}/ACTYPELIST/${idTopass}/-/-/-`
      );
    }
  }, [selectedGroup]);

  useEffect(() => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    const currentDepartment = localStorage.getItem("currentSelectedDepartment");
    console.log("currentUser in Header", currentUser);

    if (currentUser) {
      setUserDepartment(currentUser);
    } else {
      console.log("No currentUser found in localStorage");
      setUserDepartment(null);
    }
  }, []);

  const handleDeptChange = (e) => {
    const userSelectedDepartment = e.target.value;
    setDepartment_to_pass_to_api(userSelectedDepartment);
  };

  return (
    <div className="flex h-screen bg-[#F4F7F9] text-slate-700 font-sans antialiased overflow-hidden">
      {/* 1. Left Panel: Group Navigation */}
      <div className="w-[20%] bg-white border-r border-slate-200 flex flex-col shadow-[2px_0_8px_rgba(0,0,0,0.02)] z-10">
        <div className="p-5 border-b border-slate-100 bg-white">
        <div className="flex items-center gap-2 text-blue-600">
            <Layers className="w-5 h-5" />
            <h2 className="font-bold text-lg tracking-tight text-slate-800">
              Account Class
            </h2>
          </div>
        </div>

        <div className="overflow-y-auto flex-1 p-3 space-y-1">
          {mockGroups?.map((group) => (
            <div
              key={group.id}
              onClick={() => setSelectedGroup(group)}
              className={`flex items-center justify-between cursor-pointer px-4 py-3 rounded-lg transition-all duration-200
                ${selectedGroup.id === group.id
                  
                    ? "bg-blue-600 text-white shadow-md shadow-blue-600/20"
                    : "hover:bg-slate-50 text-slate-600 active:bg-slate-100"
                }`}
            >
              <div className="flex items-center gap-3 truncate">
                <span
                  className={`text-[11px] font-bold px-1.5 py-0.5 rounded ${selectedGroup.id === group.id
                      ? "bg-white/20"
                      : "bg-slate-100 text-slate-500"
                    }`}
                >
                  {group.id}
                </span>
                <span className="truncate font-semibold text-[14px]">
                  {group.name}
                </span>
              </div>
              <ChevronRight
                className={`w-4 h-4 transition-transform ${selectedGroup.id === group.id ? "rotate-90" : "opacity-30"
                  }`}
              />
            </div>
          ))}
        </div>
      </div>

      {/* 2. Middle Panel: Group Records */}
      <div className="w-[40%] bg-white border-r border-slate-200 flex flex-col">
        <div className="p-5 border-b border-slate-100 space-y-4">
          <div className="flex items-center justify-between">
            <h2 className="text-[17px] font-bold text-slate-800 flex items-center gap-2">
            <Hash className="w-4 h-4 text-blue-600" /> Account Group
            </h2>
            <button
              onClick={() => setShowGroupLevelForm((prev) => !prev)}
              className="flex items-center gap-1.5 bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded-md text-sm font-semibold transition-all active:scale-95"
            >
              <Plus className="w-4 h-4" /> New
            </button>
          </div>

          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
            <input
              placeholder="Search group records..."
              className="w-full pl-10 pr-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:bg-white focus:ring-2 focus:ring-[#009688]/10 focus:border-[#009688] outline-none transition-all"
              onChange={(e) => setSearchTextFilterTable(e.target.value)}
            />
          </div>
        </div>

        <div className="flex-1 overflow-auto">
          <table className="w-full border-separate border-spacing-0">
            <thead className="sticky top-0 bg-slate-50/90 backdrop-blur-md z-10 border-b border-slate-200">
              <tr className="text-[11px] font-bold text-slate-500 uppercase ">
                <th className="px-4 py-3 text-left border-b border-slate-200">
                  Type
                </th>
                <th className="px-4 py-3 text-left border-b border-slate-200">
                  Description
                </th>
                <th className="px-4 py-3 text-center border-b border-slate-200">
                  CT %
                </th>
                <th className="px-4 py-3 border-b border-slate-200"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {filteredAccList?.map((item, idx) => (
                <tr
                  key={idx}
                  onClick={() => setSelectAccGroupRow(item)}
                  className={`group cursor-pointer transition-colors
                    ${selectAccGroupRow?.TYPE === item.TYPE
                     
                      ? "bg-blue-100 border-l-4 border-l-blue-600"
  : "hover:bg-slate-50 border-l-4 border-l-transparent"
                    }`}
                >
                  <td className="px-4 py-2 font-bold text-slate-700 whitespace-nowrap">
                    {item.TYPE}
                  </td>
                  <td
                    title={item.DESCRIPTION}
                    className="px-4 py-2 text-slate-600 truncate max-w-[180px]"
                  >
                    {item.DESCRIPTION}
                  </td>
                  <td className="px-4 py-2 text-center font-mono text-sm text-slate-500">
                    {item.CT_Perc}%
                  </td>
                  <td className="px-4 py-2 text-right">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowGroupLevelForm(true);
                        setAccToEdit(item);
                      }}
                      className="p-1.5 rounded-md bg-blue-100 text-blue transition-all"
                    >
                      <Edit3 className="w-4 h-4" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* 3. Right Panel: Accounts Ledger */}
      <div className="w-[40%] bg-white flex flex-col">
        <div className="p-5 border-b border-slate-100 space-y-4 bg-slate-50/30">
          <div className="flex items-center justify-between">
            <h2 className="text-[17px] font-bold text-slate-800 flex items-center gap-2">
              <BookOpen className="w-4 h-4 text-blue-500" /> Account Ledger
            </h2>
            <button
              onClick={() => setShowAccountRegForm(true)}
              className="flex items-center gap-1.5 bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded-md text-sm font-semibold transition-all active:scale-95"
            >
              <Plus className="w-4 h-4 text-white" /> Add Account
            </button>
          </div>

          <div className="flex gap-2">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <input
                placeholder="Search ledger accounts..."
                className="w-full pl-10 pr-4 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:ring-2 focus:ring-[#009688]/10 outline-none"
                onChange={(e) => setSearchTextFilterTableByType(e.target.value)}
              />
            </div>

            <FormControl size="small" sx={{ minWidth: 140 }}>
              <Select
                value={department_to_pass_to_api}
                onChange={handleDeptChange}
                displayEmpty
                sx={{
                  height: 40,
                  borderRadius: "8px",
                  fontSize: "13px",
                  backgroundColor: "white",
                }}
              >
                <MenuItem value="">
                  <span className="text-slate-400 flex items-center gap-2">
                    <Filter className="w-3 h-3" /> Department
                  </span>
                </MenuItem>
                {userDepartmentList?.map((itemDept) => (
                  <MenuItem
                    key={itemDept.DEPTNO}
                    value={itemDept.DEPTNO?.trim()}
                  >
                    {itemDept.DEPTNO?.trim()}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>

        <div className="flex-1 overflow-auto bg-white">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-slate-50/50">
                <th className="px-4 py-3 text-left text-[11px] font-bold text-slate-400 uppercase border-b border-slate-100">
                  Account
                </th>
                <th className="px-4 py-3 text-left text-[11px] font-bold text-slate-400 uppercase border-b border-slate-100">
                  Description
                </th>
                <th className="px-4 py-3 text-left text-[11px] font-bold text-slate-400 uppercase border-b border-slate-100">
                  Narration
                </th>{" "}
                <th className="px-4 py-3 text-left text-[11px] font-bold text-slate-400 uppercase border-b border-slate-100">
                  DEPT
                </th>
                <th className="px-4 py-3 border-b border-slate-100"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {filteredAccListByType?.map((item, idx) => (
                <tr
                  key={idx}
                  className="group hover:bg-slate-50/80 transition-colors"
                >
                  <td className="px-4 py-2 font-semibold text-black text-sm">
                    {item.ACCOUNT}
                  </td>
                  <td
                    title={item.DESCRIPTION}
                    className="px-4 py-2 text-slate-700  max-w-[190px] text-sm font-medium"
                  >
                    {item.DESCRIPTION}
                  </td>
                  <td className="px-4 py-2 text-slate-400 truncate max-w-[140px] text-xs ">
                    {item["DEFAULT NARRATION"]}
                  </td>{" "}
                  <td className="px-4 py-2 text-slate-400 truncate max-w-[140px] text-xs ">
                    {item.Deptno}
                  </td>
                  <td className="px-4 py-2 text-right">
                    <button
                      onClick={() => {
                        setShowAccountRegForm(true);
                        setAccToEditAccountForm(item);
                      }}
                      className="p-1 rounded-md bg-blue-100 text-blue transition-all"
                    >
                      <Edit3 className="w-4 h-4" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Modal
        title={accToEdit ? "Edit Group" : "New Group"}
        isOpen={showGroupLevelForm}
        onClose={() => {
          setShowGroupLevelForm(false);
          setAccToEdit(null);
          setShowGroupLevelForm((prev) => !prev);
        }}
        header={true}
        showFullScreen={false}
      // size="lg"
      >
        <GroupLevelFormPopup
          selectedGroup={selectedGroup}
          setShowGroupLevelForm={setShowGroupLevelForm}
          successfullyDone={successfullyDone}
          accToEdit={accToEdit}
          setAccToEdit={setAccToEdit}
        />
      </Modal>
      <Modal
        title={accToEditAccountForm ? "Edit Account" : "New Account"}
        isOpen={showAccountRegForm}
        onClose={() => {
          setShowAccountRegForm(false);
          setAccToEditAccountForm();
        }}
        header={true}
        showFullScreen={false}
        size="xl"
      >
        <AccountRegFormPopup
          setShowAccountRegForm={setShowAccountRegForm}
          selectAccGroupRow={selectAccGroupRow}
          successfullyDone={successfullyDone}
          accToEditAccountForm={accToEditAccountForm}
          setAccToEditAccountForm={setAccToEditAccountForm}
        />
      </Modal>
    </div>
  );
};

export default GroupAndLedgerManagement;
